import snarkdown from 'snarkdown';

import { processNewParagraph } from 'wanderu-utils';

function appendLocaleToRelativeLinks(translation, locale) {
    const linkIdentifier = /]\(\//g;
    return translation.replace(linkIdentifier, `](/${locale}/`);
}

const mapAmenities = (content) => {
    const match = /(Header|Description)$/;
    const amenitiesKeys = Object.keys(content).filter(key => key.indexOf('amenities') === 0);
    const prefixes = amenitiesKeys.reduce((set, key) => {
        if (key.match(match)) {
            const prefix = key.split(match)[0];
            set.add(prefix);
        }
        return set;
    }, new Set());

    return [...prefixes].map(prefix => ({
        description: content[`${prefix}Description`],
        key: `${prefix}Description`,
        prefix,
        title: content[`${prefix}Header`],
    })).filter(prefix => prefix.title && prefix.description);
};

const isInvalidUrl = (url) => {
    return !url.split('--')[1] || !url.split('--')[1].replace('/', '');
};

const localizeStructuredData = ({
    locale,
    structuredData,
    t,
}) => {
    return structuredData.map((data) => {
        if (data.description) {
            const descriptionKey = data.description;
            const translation = t(descriptionKey);
            const description = appendLocaleToRelativeLinks(translation, locale);

            return {
                ...data,
                description: snarkdown(description),
            };
        }

        if (data['@type'] === 'FAQPage') {
            return {
                ...data,
                mainEntity: data.mainEntity.map((item) => {
                    const answer = item.acceptedAnswer.text;
                    const localizedAnswer = appendLocaleToRelativeLinks(answer, locale);

                    return {
                        ...item,
                        acceptedAnswer: {
                            ...item.acceptedAnswer,
                            text: snarkdown(localizedAnswer),
                        },
                        name: snarkdown(item.name),
                    };
                }),
            };
        }

        return data;
    });
};

const processCarriers = (carriers) => {
    const filteredCarriersToProcess = carriers.filter((carrier) => {
        return !!Object.keys(carrier).length && !!Object.keys(carrier.content).length;
    });

    return filteredCarriersToProcess.map((carrier) => {
        let procesedCarrier = {
            ...carrier,
            content: processNewParagraph(carrier.content),
        };

        if (!carrier.metrics) {
            procesedCarrier.metrics = {
                averageDailyTrips: 1,
                averageDurationMinutes: 1,
                averagePriceUsd: 1,
                minPriceUsd: 1,
                weekendPriceUsd: 1,
            };
        }

        return procesedCarrier;
    });
};

export {
    isInvalidUrl,
    localizeStructuredData,
    mapAmenities,
    processCarriers,
};
